import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import StaffDisplay from './components/StaffDisplay';
import EditorPanel from './components/EditorPanel';
import BPMControl from './components/BPMControl';
import DocsViewer from './components/DocsViewer';

function App() {
  // 页面状态
  const [currentPage, setCurrentPage] = useState('home'); // 'home', 'editor', 'docs-zh', 'docs-en'
  
  // 编辑器状态
  const [notes, setNotes] = useState([]);
  const [bpm, setBpm] = useState(60);
  const [timeSignature, setTimeSignature] = useState('4/4'); // 拍号，默认4/4拍
  const [currentInstrument, setCurrentInstrument] = useState('meow');
  const [currentDuration, setCurrentDuration] = useState(1); // 默认1/4拍（1个四分音符）
  const [selectedMeow, setSelectedMeow] = useState('01'); // 默认选择喵喵琴-1
  
  // 页面导航
  const handleNavigate = (page) => {
    setCurrentPage(page);
  };

  const addNote = (meow, song) => {
    // 检查是否是休止符（meow='00' and song='00'）
    const isRest = meow === '00' && song === '00';
    
    // 计算音符时长（毫秒）= 节拍数 * (60000ms / BPM)
    // 在简谱中，1拍 = 四分音符
    const beatDuration = 60000 / bpm; // 一拍（四分音符）的毫秒数
    
    let timeInMs;
    if (isRest) {
      // 休止符：time = 0，但需要存储实际时长用于播放
      // 我们使用负数来表示休止符的时长
      timeInMs = -Math.round(currentDuration * beatDuration);
    } else {
      timeInMs = Math.round(currentDuration * beatDuration);
    }
    
    const newNote = {
      meow: meow,
      song: song,
      time: timeInMs // 音符持续时间（正数：音符，负数：休止符）
    };
    setNotes([...notes, newNote]);
  };

  const deleteNote = (index) => {
    const newNotes = notes.filter((_, i) => i !== index);
    setNotes(newNotes);
  };

  const clearAll = () => {
    if (window.confirm('确定要清空所有音符吗？')) {
      setNotes([]);
    }
  };

  const exportData = () => {
    const dataStr = JSON.stringify(notes, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'meowchoir-score.json';
    link.click();
    URL.revokeObjectURL(url);
  };

  const importData = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const importedNotes = JSON.parse(e.target.result);
          setNotes(importedNotes);
          alert('导入成功！');
        } catch (error) {
          alert('导入失败，文件格式错误！');
        }
      };
      reader.readAsText(file);
    }
  };

  // 渲染页面内容
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <Home onNavigate={handleNavigate} />;
      
      case 'editor':
        return (
          <>
            <BPMControl 
              bpm={bpm} 
              setBpm={setBpm}
              timeSignature={timeSignature}
              setTimeSignature={setTimeSignature}
              onExport={exportData}
              onImport={importData}
              onClear={clearAll}
            />

            <div className="main-container">
              <div className="staff-section">
                <StaffDisplay 
                  notes={notes} 
                  bpm={bpm} 
                  timeSignature={timeSignature} 
                  onDeleteNote={deleteNote}
                  selectedMeow={selectedMeow}
                  onSelectMeow={setSelectedMeow}
                />
              </div>
              
              <div className="editor-section">
                <EditorPanel 
                  currentInstrument={currentInstrument}
                  setCurrentInstrument={setCurrentInstrument}
                  currentDuration={currentDuration}
                  setCurrentDuration={setCurrentDuration}
                  onAddNote={addNote}
                  selectedMeow={selectedMeow}
                />
              </div>
            </div>
          </>
        );
      
      case 'docs-zh':
        return <DocsViewer lang="zh" />;
      
      case 'docs-en':
        return <DocsViewer lang="en" />;
      
      default:
        return <Home onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className="App">
      <Header 
        currentPage={currentPage} 
        onNavigate={handleNavigate}
      />
      
      <div className="app-content">
        {renderPage()}
      </div>
    </div>
  );
}

export default App;

